<template>
  <div v-if="attendances">
    <h1 class="text-h5 text-center mb-3">
      {{ month }}
    </h1>
    <v-row no-gutters>
      <v-col
        v-for="attendance in attendances"
        :key="attendance.attendanceDate"
      >
        <div
          class="text-center"
          @click="dateClick(attendance)"
        >
          <div :class="{ 'red--text': isHoliday(attendance) }">
            {{ dayOfWeek(attendance.attendanceDate) }}
          </div>
          <v-btn
            text
            fab
            small
            :class="{ active: isActive(attendance.attendanceDate) }"
          >
            {{ momentWithHyphen(attendance.attendanceDate).format('D') }}
          </v-btn>
          <div v-if="attendance.leaves.length">
            <v-icon
              color="orange darken-1"
              small
            >
              {{ mdiMoonFull }}
            </v-icon>
          </div>
        </div>
      </v-col>
    </v-row>

    <br>

    <v-sheet
      v-if="activeAttendance"
      color="grey lighten-3"
      class="py-3 px-5"
    >
      <h2 class="text-h6 d-inline-block mr-3">
        {{ activeAttendance.attendanceDate }}
      </h2>
      <v-chip
        v-if="activeAttendance.holidayChinName"
        color="red"
        small
        label
        dark
      >
        {{ $chPtObjData('holidayChinName', activeAttendance) }}
      </v-chip>

      <div class="mt-1">
        <s-attendance-time
          :daily-times="activeAttendance.listStaffAttendance"
          margin-class="mr-3"
        />
      </div>

      <v-tooltip
        v-for="leaveReason in activeAttendance.leaves"
        :key="leaveReason.startTime"
        color="black"
        top
      >
        <template v-slot:activator="{ on }">
          <v-chip
            small
            class="mr-2"
            color="orange darken-2"
            dark
            v-on="on"
          >
            {{ leaveReason.desc }}
          </v-chip>
        </template>
        <span v-if="leaveReason.hasTime">
          {{ momentWithHyphen(leaveReason.startTime).format('HH:mm') }} ~ {{ momentWithHyphen(leaveReason.endTime).format('HH:mm') }}
        </span>
        <span v-else>{{ $t('PublicServant.AbsentSupplementary.Detail.WholeDay') }}</span>
      </v-tooltip>

      <div>
        {{ activeAttendance.obser }}
      </div>

      <br>
      <div>
        <span class="text-subtitle-2"> {{ $t('Attendance.OnlineAdjustWorkingHour') }}*:</span>
        {{ secondToHourMinute(activeAttendance.adjustmentDailySettlementAmount) }}
      </div>
    </v-sheet>
  </div>
</template>

<style scoped>
  .v-btn.active {
    background: #00BCD4;
    color: white;
  }
</style>

<script>

import SAttendanceTime from './SAttendanceTime'
import { attendanceTableMixin } from '../mixins/attendanceTableMixin'
import { dateToMonthString, momentWithHyphen } from '@/utils/datetimeUtil'
import { mdiMoonFull } from '@mdi/js'

export default {
  components: {
    SAttendanceTime
  },
  // attendances come from this mixin
  mixins: [attendanceTableMixin],
  data: function () {
    return {
      activeAttendance: null,
      mdiMoonFull: mdiMoonFull
    }
  },
  computed: {
    month: function () {
      if (this.attendances && this.attendances.length > 0) {
        let startDate = momentWithHyphen(this.attendances[0].attendanceDate)
        let endDate = momentWithHyphen(this.attendances[6].attendanceDate)
        if (startDate.month() === endDate.month()) {
          return dateToMonthString(startDate, this.$i18n.locale)
        } else {
          return dateToMonthString(startDate, this.$i18n.locale, 'short') + ' - ' + dateToMonthString(endDate, this.$i18n.locale, 'short')
        }
      } else {
        return null
      }
    }
  },
  created: function () {
    if (this.attendances && this.attendances.length) {
      this.setDefaultActiveAttendance()
    }
  },
  methods: {
    isActive: function (attendanceDate) {
      if (attendanceDate === this.activeAttendance.attendanceDate) {
        return true
      } else {
        return false
      }
    },
    dateClick: function (attendance) {
      this.activeAttendance = attendance
    },
    setDefaultActiveAttendance: function () {
      if (this.attendances && this.attendances.length) {
        // default set to now day, if not, set to Monday
        this.activeAttendance = this.attendances[1]

        let date = new Date()
        this.attendances.forEach(attendance => {
          if (attendance.attendanceDate === momentWithHyphen(date).format('YYYY-MM-DD')) {
            this.activeAttendance = attendance
          }
        })
      }
    },
    changeActiveDate: function (number) {
      if (this.attendances && this.attendances.length) {
        let activeIndex = null
        this.attendances.forEach((attendance, index) => {
          if (this.isActive(attendance.attendanceDate)) {
            activeIndex = index
          }
        })
        let newActiveIndex = activeIndex + number
        if (newActiveIndex >= 0 && newActiveIndex <= this.attendances.length) {
          this.activeAttendance = this.attendances[newActiveIndex]
        }
      }
    },
    momentWithHyphen: momentWithHyphen
  }
}
</script>
